export function handleUnauthorized(response: any, logout: any) {
  const statusCode = response?.status;
  const msgError = response.content?.title! || response.data?.content?.title!;
  if (statusCode === 401 && msgError === "Unauthorized access") {
    logout();
  }
}
